"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InfoAreaIconTitleListColor;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components
function InfoAreaIconTitleListColor(_ref) {
  var icon = _ref.icon,
      iconColor = _ref.iconColor,
      title = _ref.title,
      description = _ref.description,
      list = _ref.list;
  var newDescription = [];

  if (!Array.isArray(description)) {
    newDescription = [description];
  } else {
    newDescription = description;
  }

  var iconBgColor = {
    blueGray: "text-blueGray-500 bg-blueGray-200",
    red: "text-red-500 bg-red-200",
    orange: "text-orange-500 bg-orange-200",
    amber: "text-amber-500 bg-amber-200",
    emerald: "text-emerald-500 bg-emerald-200",
    teal: "text-teal-500 bg-teal-200",
    lightBlue: "text-lightBlue-500 bg-lightBlue-200",
    indigo: "text-indigo-500 bg-indigo-200",
    purple: "text-purple-500 bg-purple-200",
    pink: "text-pink-500 bg-pink-200"
  };
  var listIconBgColor = {
    blueGray: "text-blueGray-500 bg-blueGray-200",
    red: "text-red-500 bg-red-200",
    orange: "text-orange-500 bg-orange-200",
    amber: "text-amber-500 bg-amber-200",
    emerald: "text-emerald-500 bg-emerald-200",
    teal: "text-teal-500 bg-teal-200",
    lightBlue: "text-lightBlue-500 bg-lightBlue-200",
    indigo: "text-indigo-500 bg-indigo-200",
    purple: "text-purple-500 bg-purple-200",
    pink: "text-pink-500 bg-pink-200"
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: iconBgColor[iconColor] + " p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-rocket text-xl"
  })), /*#__PURE__*/_react.default.createElement("h3", {
    className: "text-3xl font-semibold"
  }, title), newDescription.map(function (prop, key) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "mt-4 text-lg leading-relaxed text-blueGray-500",
      key: key
    }, prop);
  }), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-none mt-6"
  }, list.map(function (prop, key) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "py-2",
      key: key
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
      className: listIconBgColor[iconColor] + " text-xs font-semibold inline-block w-8 h-8 flex items-center justify-center uppercase rounded-full mr-3"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: prop.icon
    }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", {
      className: "text-blueGray-500"
    }, prop.text))));
  })));
}

InfoAreaIconTitleListColor.defaultProps = {
  iconColor: "blueGray",
  description: [],
  list: []
};
InfoAreaIconTitleListColor.propTypes = {
  // icon name to be added on the <i></i> tag, for example "fa fa-heart"
  icon: _propTypes.default.string.isRequired,
  // the background of the icon
  // NOTE: this color will also be added to the list icons of down below
  iconColor: _propTypes.default.oneOf(["blueGray", "red", "orange", "amber", "emerald", "teal", "lightBlue", "indigo", "purple", "pink"]),
  title: _propTypes.default.string,
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    // icon name to be added on the <i></i> tag, for example "fa fa-heart"
    icon: _propTypes.default.string.isRequired,
    // text to go with the icon
    text: _propTypes.default.string.isRequired
  }))
};
